import React, { ReactNode } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { showNotification } from "fe-shared/src/components";
import FileItem from "fe-shared/src/components/FileList/FileItem";
import { CloseIcon } from "fe-shared/src/components/Icons";

import { Transfer, DocumentsResponse, Address } from "../../types";

import * as api from "./modules/api";

import styles from "./DocumentsInfo.module.scss";

interface Props {
  attachments?: DocumentsResponse[];
  title?: string | ReactNode;
  isEditable?: boolean;
  address?: Address;
  transfer?: Transfer;
}

const onDownloadFile = (
  fileName: string,
  path: string,
  t: (key: string) => string
) => {
  api.downloadFile(path, fileName).catch(() => {
    showNotification(t("errors.fileDownloadError"), undefined, CloseIcon);
  });
};

const DocumentsInfo = ({ attachments = [], title }: Props) => {
  const { t } = useTranslation();

  const onDownload = (path: string) => (id: string, filename: string) =>
    onDownloadFile(filename, path, t);

  return (
    <>
      <div className={classnames({ [styles.documentsInfoWrapper]: !!title })}>
        {title && (
          <div className={styles.titleWrapper}>
            <span className={styles.documentsInfoTitle}>{title}</span>
          </div>
        )}
        {attachments?.map(({ documentPath, ...rest }) => (
          <FileItem
            disabled
            isDownloadActive
            isViewOnly
            id={documentPath}
            key={documentPath}
            onDownload={onDownload(documentPath!)}
            {...rest}
          />
        ))}
        {!attachments?.length && (
          <span className={styles.emptyState}>
            {t("transactions.documents.emptyState")}
          </span>
        )}
      </div>
    </>
  );
};

export default DocumentsInfo;
